import { Card } from '@zillow/constellation-10';
import { Bone } from '@zg-rentals/satellite-components';
import SkeletonContainer from '../SkeletonContainer';
import { DEFAULT_LEADS_PER_PAGE } from '../LeadManagementTable/Skeleton';

type LeadManagementCardsSkeletonProps = {
  numberOfCards?: number;
};

export default function LeadManagementCardsSkeleton({ numberOfCards }: LeadManagementCardsSkeletonProps) {
  const skeletonCards = Array(numberOfCards || DEFAULT_LEADS_PER_PAGE).fill('');

  return (
    <>
      {skeletonCards.map((_, index) => {
        return (
          <Card
            key={index}
            tone="neutral"
            css={{
              marginTop: 'default',
              paddingTop: 'tighter',
            }}
          >
            <SkeletonContainer>
              <>
                <Bone css={{ width: '33.33%', marginTop: 10.4, marginBottom: 'default' }} />
                <Bone css={{ width: '41.67%', marginBottom: 'default' }} />
                <Bone css={{ width: '75%', marginBottom: 'default' }} />
                <Bone css={{ width: '33.33%', marginTop: 'default', marginBottom: 'tighter' }} />
              </>
            </SkeletonContainer>
          </Card>
        );
      })}
    </>
  );
}
